let api_endpoint = "http://localhost/backwalk/api/v1/";
let web_socket_endpoint = "ws://127.0.0.1:9000"
let system = "develop"

if (process.env.NODE_ENV === 'production') {
    if (process.env.REACT_APP_SYSTEM === 'stage') {
        api_endpoint = 'https://stage.walkingtalking.com/backwalk/api/v1/'
        web_socket_endpoint = "wss://stage.walkingtalking.com:443/wss"
        system = "stage"
    } else {
        api_endpoint = 'https://app.walkingtalking.com/backwalk/api/v1/'
        web_socket_endpoint = "wss://app.walkingtalking.com:443/wss"
        system = "prod"
    }
}

export interface AppConfig {
    API_ENDPOINT: string,
    WEB_SOCKET_ENDPOINT: string,
    SYSTEM: string,
    VERSION: string,
    NAME: string,
    TOKEN_NAME: string,
    EMAIL_NAME: string,
    LANGUAGE_NAME: string,
    GOOGLE_KEY: string,
}

export const CONFIG: AppConfig = {
    API_ENDPOINT : api_endpoint,
    WEB_SOCKET_ENDPOINT: web_socket_endpoint,
    SYSTEM: system,
    VERSION : "1.0.0",
    NAME : "WalkingApp",
    TOKEN_NAME : 'walking_token',
    EMAIL_NAME : 'walking_email',
    LANGUAGE_NAME: 'walking_language',
    GOOGLE_KEY : 'AIzaSyAZbpv_X-MhMjKDnhqvWk4Xz1bC772NhSQ'
    // GOOGLE_KEY: 'AIzaSyCbCmn65xqc6rOIp5D4sZf3VKpaAnmNIPI', Håkans
    // GOOGLE_KEY: 'AIzaSyBDgpT-yQSQoTB1MbcGvunXwHG0HX8ZMx4',
};
